// extracted by mini-css-extract-plugin
module.exports = {"list":"_1_p3WGI5-r9Yop1e0kpOud","recall":"_3bGwErpEZ7G1Hsxa5d3ptE","info":"_96UF01k-AWsuCNpWP_QvC"};